import axiosInstance from './axiosInstance';

export interface Hospital {
  hospitalId: number;
  hospitalName: string;
}

export interface CreateAppointmentPayload {
  userId: number;
  receptionChannel: string;
  insuranceCompanyName: string;
  customerName: string;
  customerContacts: string[];
  consultType: 'FREE_APPOINT';
  consultProgressStatus: 'REQUESTED';
  insuranceProduct: string;
  treatmentContent: string;
  detailedTreatmentContent: string;
  isInsurancePayment: boolean;
  finalLossAdjuster: string;
  totalFee: string;
  defaultPayment: number;
  extraPayment: number;
  hospitals: Hospital[];
  // region: string;
  isWhatsonExposed: boolean;
  requestedAt: string;
  isReviewExposed: boolean;
  claimProcess: string;
  // claimedAt: string;
  insuredName: string;
  adjusterId: number; // ← ❗타입에 없음
  clientId: number; // ← ❗타입에 없음
}

export const createAppointment = async (payload: CreateAppointmentPayload) => {
  console.log('[🔥 최종 payload]', payload);
  const response = await axiosInstance.post('/api/admin/v1/consults', payload);
  return response.data;
};
